<template>
    <!-- 首页 - 二级标题 -->
    <div>
        <div class="title-box-primary flex-align-center">
            <h2 class="title">{{ title }}</h2>
            <div class="more-box" @click="gotoLink">
                <slot>
                    <el-button type="text">更多</el-button>
                </slot>
            </div>
        </div>
        <hr />
    </div>
</template>
<script>
export default {
    props: ["title", "url", "target"],
    methods: {
        gotoLink() {
            if (this.target === "_blank") {
                let pathInfo = this.$router.resolve({
                    path: this.url,
                });
                window.open(pathInfo.href, "_blank");
            } else {
                this.$router.push(this.url);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.title-box-primary {
    padding-top: 60px;
    padding-bottom: 16px;

    .title {
        line-height: 1;
        padding-left: 44px;
        background: url(~@/assets/images/title-icon.png) left center / 24px auto
            no-repeat;
        color: #12214d;
        font-size: 24px;
        font-weight: bold;
    }
    .more-box {
        position: relative;
    }
    .more-box .el-button--text {
        padding: 0px 16px 0 0;
        border: 0;
        font-size: 16px;
        color: #6c6b76;
        font-weight: bold;
        background: url(~@/assets/images/arrow-right.png) right center / 16px
            no-repeat;
    }
    .more-box ::v-deep .el-button--text span {
        vertical-align: middle;
    }
}
</style>